<h2 class="max-width">
  {{ data?.content?.text }}
</h2>
